import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgButtonRightFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M10 19c1.8 0 3.5-.5 5-1.5s2.6-2.4 3.3-4 .9-3.5.5-5.2c-.3-1.7-1.2-3.3-2.5-4.6s-2.9-2.1-4.6-2.5-3.5-.2-5.1.5C4.9 2.4 3.5 3.5 2.5 5S1 8.2 1 10c0 2.4 1 4.7 2.6 6.4C5.3 18 7.6 19 10 19m-.9-5.2-1.2-1.2 2.5-2.6-2.5-2.4L9 6.4l3.8 3.6z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgButtonRightFilled);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
